<template>
  <main-layout>
    <div class="top">
      <div class="container top-container">
        <div class="top_live">
          <div class="detailImg">
            <span
              class="status status-notstarted"
              v-if="liveList.liveStatus == 2"
              >{{ $t("live.即将开始") }}</span
            >
            <span class="status status-living" v-if="liveList.liveStatus == 1">
              <img src="/static/icon_app_live_on_white.gif" alt />
              {{ $t("live.直播中") }}
            </span>
            <span
              class="status status-closed"
              v-if="liveList.liveStatus == 3"
              >{{ $t("global.已结束") }}</span
            >
            <img
              class="topImg"
              :src="liveList.horizontalThumb | imageUrl('https://image.manamana.net/1641283406000_WOWHgtGT', 890, 500)"
              alt
            />
          </div>
          <div class="liveDetail">
            <p class="title1">{{ liveList.title }}</p>
            <p class="title2" v-if="liveList.intro">{{ liveList.intro }}</p>
            <p class="distinguished">
              <span class="left">{{ $t("live.嘉宾") }}：</span>
              <span
                :class="[item.userId ? 'cor' : '']"
                v-for="(item, i) in liveList.guestResponse"
                :key="i"
                @click="gotoPeopleCenter(item.userId)"
                @mouseenter="index = i"
                @mouseleave="index = null"
              >
                {{ item.nickName }}
                <i></i>
              </span>
            </p>
            <p class="time" v-if="liveList.liveStartTime">
              <span>{{ $t("global.开始时间") }}：</span>
              {{ formatDate(liveList.liveStartTime) }}
            </p>
            <p class="price">
              <span v-if="liveList.price > 0" class="price">
                ￥
                <b>{{ liveList.price }}</b>
              </span>
              <span
                v-if="liveList.price == 0 || liveList.price == null"
                class="free"
              >
                <b>{{ $t("global.免费") }}</b>
              </span>
            </p>
            <div class="bottom">
              <span
                v-if="
                  liveList.price == 0 ||
                  (liveList.isBuy && liveList.payStatus == 1)
                "
              >
                <span
                  class="bottom1"
                  v-if="liveList.liveStatus == 1 || liveList.liveStatus == 2"
                  @click="gotoLive"
                  >{{ $t("live.进入直播间") }}</span
                >
                <div v-if="liveList.liveStatus == 2" class="sub">
                  <span
                    class="bottom5"
                    v-if="liveList.isSub"
                    @click.stop.prevent="closeSub(liveList.id)"
                  >
                    <i class="hover1">{{ $t("live.已订阅") }}</i>
                    <i class="hover2">{{ $t("live.取消订阅") }}</i>
                  </span>
                  <el-popover
                    placement="bottom"
                    width="175px"
                    trigger="hover"
                    v-else
                  >
                    <div class="tixing">
                      {{ $t("live.开播前短信/服务号/App通知") }}
                    </div>
                    <span
                      class="bottom2"
                      slot="reference"
                      @click.stop.prevent="subscribe(liveList.id)"
                    >
                      <img
                        src="/static/web_live_details_notif_icon@2x.png"
                        alt
                      />
                      {{ $t("live.订阅") }}
                    </span>
                  </el-popover>
                </div>
                <span
                  class="bottom4"
                  v-if="liveList.liveStatus == 3"
                  @click="gotoLive"
                  >{{ $t("live.进入回看") }}</span
                >
              </span>
              <span v-else class="bottom4" @click="gotoPay">{{
                $t("live.立即购买")
              }}</span>
              <el-popover placement="bottom" width="240px" trigger="hover">
                <share :config="config"></share>
                <span class="bottom3" slot="reference">{{
                  $t("global.分享")
                }}</span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="container middle-container">
        <div class="middle-left">
          <div class="distinguishedList">
            <p class="video-other-title">{{ $t("live.直播嘉宾") }}</p>
            <div class="box">
              <div v-for="(guests, index) in liveList.guestList" :key="index">
                <div
                  class="vedio-name video-other"
                  v-for="(item, index) in guests"
                  :class="[item.userId ? 'cor' : '']"
                  :key="index"
                  @click="gotoPeopleCenter(item.userId)"
                >
                  <div class="img">
                    <img
                      class="vedio-avatar"
                      :src="
                        item.icon
                          | imageUrl(
                            '/static/profile_img_default.png',
                            100,
                            100
                          )
                      "
                      @click="goToUserPage(item.userId)"
                    />
                  </div>
                  <div class="vedio-name-center-top">
                    <p class="nickname">{{ item.nickName }}</p>
                    <p class="guestTitle">{{ item.guestTitle }}</p>
                  </div>
                </div>
              </div>
              <!--<div
                class="vedio-name video-other"
                v-for="(item, index) in liveList.guestResponse"
                :key="index"
                @click="gotoPeopleCenter(item.userId)"
              >
                <div class="img">
                  <img
                    class="vedio-avatar"
                    :src="item.icon | imageUrl"
                    @click="goToUserPage(item.userId)"
                  />
                </div>
                <div class="vedio-name-center-top">
                  <p :class="['nickname', item.userId?'':'cor']">{{ item.nickName }}</p>
                  <p class="guestTitle">{{ item.guestTitle }}</p>
                </div>
              </div>-->
            </div>
          </div>
          <div class="detail">
            <p class="title_detail">{{ $t("live.直播详情") }}</p>
            <div class="liveText" v-html="liveList.introduction"></div>
          </div>
        </div>
        <div class="middle-right">
          <div
            class="middle-right-1"
            v-if="hotEventsList && hotEventsList.length"
          >
            <div class="top-right-top">
              <div class="section-title">
                <span class="title-span">{{ $t("live.推荐直播") }}</span>
                <router-link to="/live/list" class="viewAll" target="_blank">{{
                  $t("global.查看全部")
                }}</router-link>
                <span class="icon"></span>
              </div>
              <div class="top-right-top-list">
                <router-link
                  target="_blank"
                  :to="'/live/liveDetail?id=' + item.id"
                  v-for="(item, i) in hotEventsList"
                  :key="i"
                  class="hot"
                >
                  <div class="img">
                    <img
                      :src="item.verticalThumb | imageUrl('', 190, 252)"
                      alt
                    />
                    <p class="now" v-if="item.liveStatus == 1">
                      {{ $t("live.直播中") }}
                    </p>
                    <p class="soon" v-if="item.liveStatus == 2">
                      {{ $t("live.即将开始") }}
                    </p>
                  </div>
                  <div class="title">
                    <p class="title1">{{ item.title }}</p>
                    <p class="title2">{{ formatDate(item.liveStartTime) }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div
            class="middle-right-1"
            v-if="liveList.topicResponses && liveList.topicResponses.length"
          >
            <div class="top-right-top">
              <div class="section-title">
                <span class="title-span">{{ $t("global.相关频道") }}</span>
              </div>
              <div class="top-right-top-list">
                <router-link
                  target="_blank"
                  :to="'/subjectDetail/' + item.topicId + '/home'"
                  v-for="(item, i) in liveList.topicResponses"
                  :key="i"
                  class="channel"
                >
                  <div class="img">
                    <img :src="item.thumb | imageUrl('', 130, 130)" alt />
                  </div>
                  <div class="text">
                    <p class="title1">{{ item.title }}</p>
                    <p class="title2">
                      <span>{{ $t("global.视频") }} {{ item.videoCount }}</span>
                      <span
                        >{{ $t("global.成员") }} {{ item.memberCount }}</span
                      >
                    </p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="middle-right-1">
            <img
              class="app_promo"
              src="/static/vedio/Sidebar_app_promo@2x.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <div class="popup" v-if="isPopupShow">
      <div class="popupBox" v-if="subTer">
        <p class="title">
          {{ $t("live.订阅直播") }}
          <span @click="closePopup"></span>
        </p>
        <p class="line"></p>
        <img class="subImg" src="/static/img_subscribed@2x.png" alt />
        <p class="text">
          {{
            $t(
              "live.您已成功订阅直播提醒，直播开始前15分钟将通过短信、服务号及App推送通知。"
            )
          }}
        </p>
      </div>
      <div class="popupBox" v-else>
        <p class="title">
          {{ $t("live.取消订阅成功") }}
          <span @click="closePopup"></span>
        </p>
        <p class="line"></p>
        <img class="subImg" src="/static/img_unsubscribed@2x.png" alt />
        <p class="text">
          {{
            $t("live.您已成功取消订阅直播提醒，将不再收到该直播开始的通知。")
          }}
        </p>
      </div>
    </div>
    <service />
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import comm from "@/assets/comm.js";
import { imageUrl } from "@/util/filters.js";
import Share from "@/components/v2/Share";

export default {
  metaInfo() {
    return {
      title: "MANA " + this.$t("live.直播详情页"),
    };
  },
  components: {
    MainLayout,
    service,
    Share,
  },
  data() {
    return {
      hotEventsList: [],
      liveList: {},
      id: null,
      activityId: null,
      isPopupShow: false,
      subTer: true,
      index: null,
      config: {},
    };
  },
  beforeCreate() {
    window._bd_share_main = "";
  },
  methods: {
    gotoLive() {
      let ChromeNum = [];
      if (/Chrome/.test(navigator.userAgent)) {
        let re = new RegExp("Chrome/(.+?) ");
        let reg = /^([0-9a-zA-Z]+)\..*$/;
        let a = re.exec(navigator.userAgent)[1];
        ChromeNum = a.match(reg);
      }
      if (this.liveList.videoId) {
        let routeData = this.$router.resolve({ path: "/video/detail?id=" + this.liveList.videoId });
        window.open(routeData.href, "_blank");
      } else {
        if (
          /Safari/.test(navigator.userAgent) ||
          /Chrome/.test(navigator.userAgent)
        ) {
          this.$http
            .post("/api/bytedance/auth/" + this.activityId)
            .then((res) => {
              if (res.code === "OK") {
                window.location.href = res.data;
              }
            });
        } else {
          // this.$router.push("/live/livePage?id=" + this.activityId);
          let routeData = this.$router.resolve({
            path: "/live/livePage?id=" + this.activityId,
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
    gotoPay() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(`/login?redirecturl=${window.location}`);
        return;
      }
      this.$http.get("/api/bytedance/" + this.$query.id).then((res) => {
        if (res.code == "OK") {
          if (res.data.payStatus == 0) {
            let routeData = this.$router.resolve({
              path: "/live/payDetail?orderNo=" + res.data.orderNo + "&type=2",
            });
            window.open(routeData.href, "_blank");
            return;
          }
          if (res.data.payStatus == 1) {
            this.gotoLive();
            return;
          }
          let routeData = this.$router.resolve({
            path: "/live/payDetail?id=" + this.$query.id + "&type=1",
          });
          window.open(routeData.href, "_blank");
        }
      });
    },
    gotoPeopleCenter(userId) {
      if (userId != null) {
        // this.$router.push("/peopleCenter/" + userId + "/home");
        let routeData = this.$router.resolve({
          path: "/peopleCenter/" + userId + "/home",
        });
        window.open(routeData.href, "_blank");
      }
    },
    subscribe(id) {
      this.subTer = true;
      this.$http.get("/api/bytedance/sub/" + id).then((res) => {
        if (res.code === "OK") {
          document.body.style.overflow = "hidden";
          this.isPopupShow = true;
          this.getLiveList();
        }
      });
    },
    closeSub(id) {
      this.subTer = false;
      this.$http.get("/api/bytedance/unsub/" + id).then((res) => {
        if (res.code === "OK") {
          document.body.style.overflow = "hidden";
          this.isPopupShow = true;
          this.getLiveList();
        }
      });
    },
    closePopup() {
      document.body.style.overflow = "";
      this.isPopupShow = false;
    },
    getLiveList() {
      var againGroup = function (data, num) {
        var result = [];
        for (var i = 0, len = data.length; i < len; i += num) {
          result.push(data.slice(i, i + num));
        }
        return result;
      };

      this.$http.get("/api/bytedance/" + this.$query.id).then((res) => {
        if (res.code === "OK") {
          this.liveList = res.data;
          this.config = {
            share_url: location.href,
            title: "MANA直播-" + this.liveList.title,
            desc: "MANA 全球新媒体艺术平台",
            pics: this.liveList.horizontalThumb,
          };
          this.activityId = res.data.activityId;
          this.liveList.guestList = againGroup(this.liveList.guestResponse, 3);
        }
      });
    },
    //推荐直播
    getVideoHotEvents() {
      const url = `/api/bytedance/detail/recommend/` + this.$query.id;
      this.$http.get(url).then((res) => {
        if (res.code === "OK") {
          this.hotEventsList = res.data;
          if (this.hotEventsList && this.hotEventsList.length > 3) {
            this.hotEventsList = this.hotEventsList.slice(0, 3);
          }
        }
      });
    },
  },

  created() {
    this.getVideoHotEvents();
    this.getLiveList();
    this.buriedPoint(50,this.$query.id)
  },
  mounted() {},

  watch: {
    $route(to) {
      this.getLiveList();
      this.getVideoHotEvents();
    },
  },
  computed: {},
};
</script>
<style>
.el-popover {
  min-width: auto;
}
.bdshare-button-style1-16 a {
  padding-left: 0 !important;
}
</style>

<style scoped>
.overHiden {
  overflow: hidden;
  height: 100%;
}
.minVideoPlay {
  position: fixed;
  width: 350px;
  height: 200px;
  bottom: 10px;
  right: 10px;
  z-index: 11;
}
.photoBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  padding-top: 70px;
  box-sizing: border-box;
}
.photoBox .close {
  position: absolute;
  top: 56px;
  right: 107px;
  cursor: pointer;
  z-index: 999999;
}
.photoBox .close img {
  width: 44px;
  height: 44px;
}
.photoBox .page {
  position: absolute;
  top: 633px;
  left: 48%;
  font-size: 20px;
  color: #999999;
}
.category {
  padding-right: 10px;
}

.top {
  background-color: #ffffff;
  overflow: hidden;
  zoom: 1;
  padding-top: 70px;
  /* padding-bottom: 0.3rem; */
}

.top .newLeft {
  width: 760px;
  height: 490px;
  float: left;
}
.top-container {
  /* background-color: #232323; */
  overflow: hidden;
  zoom: 1;
  /* border-radius: 0.06rem; */
}

.pic-container {
  overflow: hidden;
  zoom: 1;
  height: 533px;
  border-radius: 0.06rem;
}

.swiper-button-prev {
  background: none;
  font-size: 0.5rem;
  color: #fff;
  z-index: 1011;
  left: 2.5rem;
  top: 5.2rem;
}

.swiper-button-next {
  background: none;
  font-size: 0.5rem;
  color: #fff;
  z-index: 1011;
  right: 2.7rem;
  top: 5.2rem;
}

.videoImg {
  display: block;
  margin: 0 auto;
  height: 533px;
}

.noimage {
  display: block;
  margin: 0 auto;
  height: 533px;
}

.top-left {
  float: left;
  width: 760px;
  height: 428px;
  position: relative;
}

.top-left video,
.top-left .video-player {
  width: 100%;
  height: 100%;
}

.top-left iframe {
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

.top-right {
  float: left;
  width: 290px;
  margin-left: 65px;
  box-sizing: border-box;
  /* border-bottom: 1px solid #333; */
  overflow: hidden;
}

.section-title {
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.section-title .autoPlay {
  float: right;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.section-title .viewAll {
  float: right;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 10, 10, 1);
  margin-right: 12px;
}
.section-title .viewAll:hover {
  border-bottom: 1px solid #0a0a0a;
}
.section-title .icon {
  position: absolute;
  width: 7px;
  height: 10px;
  background: url("/static/v2/match/view_all_tri.png");
  background-size: 100% 100%;
  right: 0;
  top: 5px;
}

.title-span {
  color: #0a0a0a;
  font-size: 20px;
  font-weight: bold;
}

.title-switch {
  font-size: 0.14rem;
  color: #777777;
  float: right;
}

.top-right-top-list {
  overflow: hidden;
}
.top-right-top-list .hot {
  height: 126px;
  margin-top: 20px;
  display: inline-block;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}
.top-right-top-list .hot .img {
  float: left;
  width: 95px;
  height: 126px;
  position: relative;
  margin-right: 10px;
}
.top-right-top-list .hot .img .now {
  position: absolute;
  width: 70px;
  height: 24px;
  background: rgba(254, 86, 48, 1);
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 24px;
  top: 6px;
  right: -48px;
}
.top-right-top-list .hot .img .soon {
  position: absolute;
  width: 70px;
  height: 24px;
  background: rgba(32, 38, 204, 1);
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 24px;
  top: 6px;
  right: -48px;
}
.top-right-top-list .hot .img img {
  width: 100%;
  height: 100%;
}
.top-right-top-list .hot .title {
  float: right;
}
.top-right-top-list .hot .title .title1 {
  max-height: 42px;
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  text-overflow: -o-ellipsis-lastline;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 180px;
  margin-top: 45px;
  margin-bottom: 8px;
  word-break: break-word;
}
.top-right-top-list .hot .title .title2 {
  height: 19px;
  font-size: 14px;
  font-family: NunitoSans-Regular, NunitoSans;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 19px;
}
.item {
  overflow: hidden;
  zoom: 1;
  height: 70px;
  /* padding: 10px 0; */
  margin-top: 20px;
  /* border-top: 0.02rem solid #333333; */
}

.item:first-child {
  border-top: none;
}

.item-left {
  width: 124px;
  height: 70px;
  float: left;
  -webkit-border-radius: 0.05rem;
  -moz-border-radius: 0.05rem;
  border-radius: 0.05rem;
}

.item-left > img {
  display: block;
  width: 100%;
  height: 70px;
}

.item-right {
  float: left;
  margin-left: 10px;
  width: 140px;
  font-size: 0;
}

.item-title {
  display: inline-block;
  width: 100%;
  font-size: 14px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-middle {
  font-size: 0.14rem;
  color: #777777;
  margin: 10px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 16px;
}

.item-bottom {
  margin-bottom: 5px;
  height: 18px;
}

.play-times-icon {
  display: inline-block;
  width: 0.14rem;
  height: 0.16rem;
  background: url("/static/vedio/playtimes.png") no-repeat center center;
  background-size: contain;
  vertical-align: middle;
  margin-right: 0.02rem;
}

.play-times {
  vertical-align: middle;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-right: 8px;
}

.item-line {
  display: inline-block;
  width: 0.02rem;
  height: 0.14rem;
  vertical-align: middle;
  margin: 0 0.1rem;
  background-color: #444444;
}

.time-icon {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("/static/vedio/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: middle;
  margin-right: 0.02rem;
}

.time {
  vertical-align: middle;
}

.item-bottom-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.item-name {
  width: 119px;
  margin-left: 5px;
  font-size: 12px;
  color: #777777;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.top-right-top-more {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #777777;
  background-color: #333333;
  cursor: pointer;
}

.top-bottom {
  height: 60px;
  line-height: 60px;
  float: left;
  width: 760px;
  padding-left: 0.2rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.06);
}
.top-bottom .right {
  float: right;
  margin-right: 20px;
}
.top-bottom .right a {
  margin-left: 20px;
}
.top-bottom .right a.color {
  color: rgba(32, 38, 204, 1);
}
.top-bottom a {
  color: #666666;
  cursor: pointer;
}

.top-bottom a.add {
  padding: 5px 10px;
  height: 26px;
  border: 1px solid rgba(32, 38, 204, 1);
  color: #2026cc;
  font-size: 12px;
  font-family: PingFang SC Medium;
}
.top-bottom a.download {
  padding: 5px 10px;
  height: 26px;
  border: 1px solid rgba(32, 38, 204, 1);
  color: #2026cc;
  font-size: 12px;
  font-family: PingFang SC Medium;
  margin: 0 18px 0 10px;
}
.top-bottom a.download1 {
  padding: 5px 10px;
  height: 26px;
  border: 1px solid rgba(224, 224, 224, 1);
  color: rgba(184, 184, 184, 1);
  font-size: 12px;
  font-family: PingFang SC Medium;
  margin: 0 18px 0 10px;
}

.top-bottom-icon {
  display: inline-block;
  vertical-align: middle;
}

.top-bottom-icon.icon-code {
  background: url("/static/video/video_share.png") no-repeat center center;
  background-size: contain;
  width: 0.28rem;
  height: 0.2rem;
  cursor: pointer;
}

.top-bottom-icon.icon-more {
  background: url("/static/video/video_more.png") no-repeat center center;
  background-size: contain;
  width: 0.28rem;
  height: 0.2rem;
  cursor: pointer;
}

.top-bottom-line {
  display: inline-block;
  width: 0.01rem;
  height: 0.2rem;
  background-color: #444444;
  vertical-align: middle;
  margin: 0 0.32rem;
}

.top-bottom-btn {
  width: 1.15rem;
  height: 0.3rem;
  line-height: 0.3rem;
  padding: 0;
  text-align: center;
  -webkit-border-radius: 0.15rem;
  -moz-border-radius: 0.15rem;
  border-radius: 0.15rem;
  background-color: #333333;
  color: #777777;
  font-size: 0.16rem;
  border: none;
  margin-right: 0.1rem;
}

.link-icon {
  display: inline-block;
  margin-right: 0.1rem;
  vertical-align: text-bottom;
  cursor: pointer;
}

.link-icon.link-icon-jubao {
  background: url("/static/vedio/jubao.png") no-repeat center center;
  background-size: contain;
  width: 0.22rem;
  height: 0.22rem;
  cursor: pointer;
}

.commentReport {
  position: absolute;
  right: 0;
}

.top-bottom .link-icon.link-icon-download {
  background: url("/static/video/download.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-download1 {
  background: url("/static/video/download_icon@2x.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-add {
  background: url("/static/video/add.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-photos {
  background: url("/static/video/photos.png") no-repeat center center;
  background-size: contain;
  width: 0.2rem;
  height: 0.2rem;
}
.top-bottom .link-icon.link-icon-clap {
  background: url("/static/video/video_clap.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-clap-active {
  background: url("/static/video/video_clap_actived.png") no-repeat center
    center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-more {
  background: url("/static/video/video_more.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-save {
  background: url("/static/video/video_save.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-save-active {
  background: url("/static/video/video_save_actived.png") no-repeat center
    center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-share {
  background: url("/static/video/video_share.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}

.switch {
  width: 2.83rem;
  height: 0.55rem;
  margin: 0.37rem auto 0;
  background: #fff;
  border-radius: 0.4rem;
  display: flex;
}

.switch > span {
  display: inline-block;
  width: 1.4rem;
  height: 0.55rem;
  line-height: 0.55rem;
  color: #333;
  font-size: 0.2rem;
  border-radius: 0.3rem;
  text-align: center;
  cursor: pointer;
  background-color: transparent;
}

.switch > span:last-child {
  margin-left: -0.03rem;
}

.switch > .switchChoose {
  background-color: #0060ff;
  color: #fff;
}

.middle {
  background-color: #ffffff;
  padding-top: 40px;
  padding-bottom: 0.8rem;
}

.middle-container {
  /* overflow: hidden; */
  zoom: 1;
}
.middle-container:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.middle-left {
  width: 760px;
  float: left;
  min-height: 1px;
}

/*
.middle-left-1,
.middle-left-2 {
  padding: 0.4rem 0.6rem 0.45rem;
} */

.middle-left-2 {
  margin-top: 0.2rem;
  padding-bottom: 0.1rem;
}

.title {
  font-size: 24px;
  color: #0a0a0a;
  float: left;
  font-weight: bold;
}

.title .tip {
  font-size: 12px;
  color: #2026cc;
  border: 1px solid rgba(32, 38, 204, 1);
  box-sizing: border-box;
  /* width: 0.7rem; */
  padding: 0 5px;
  text-align: center;
  /* height: 18px; */
  line-height: 18px;
  margin-left: 0.18rem;
  display: inline-block;
  vertical-align: middle;
}

.function {
  float: right;
  font-size: 0.22rem;
  color: #595a57;
  line-height: 0.3rem;
}

.function > label:hover {
  cursor: pointer;
}

.favourite-icon {
  width: 0.3rem;
  height: 0.26rem;
  vertical-align: top;
  font-size: 0.33rem;
  margin-right: 0.1rem;
}

.favourite-icon-active {
  color: #0060ff;
}

.recommend-icon {
  width: 0.3rem;
  height: 0.3rem;
  font-size: 0.36rem;
  vertical-align: top;
}

.recommend-icon-active {
  color: #0060ff;
}

.recommend {
  margin-left: 0.4rem;
}

.vedio-content {
  font-size: 14px;
  color: #999;
  clear: both;
  padding-top: 0.15rem;
}
.new_list {
  margin: 15px 0;
}
.new_list .value {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  background: rgba(32, 38, 204, 0.1);
  font-size: 13px;
  color: #2026cc;
}
.new_list .value img {
  width: 15px;
  height: 15px;
  vertical-align: text-top;
}
.new_tag {
  height: 26px;
  margin: 30px 0 50px 0;
}
.new_tag img {
  width: 20px;
  height: 20px;
  vertical-align: text-top;
}
.new_tag .tag {
  display: inline-block;
  padding: 0 10px;
  height: 26px;
  line-height: 26px;
  background: rgba(245, 245, 245, 1);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
  margin-bottom: 10px;
}
.vedio-content .value {
  color: #333333;
}

.vedio-content .line {
  display: inline-block;
  vertical-align: middle;
  height: 0.16rem;
  width: 0.02rem;
  background-color: #cccccc;
  margin: 0 0.2rem;
}

.vedio-name .name {
  font-size: 14px;
  color: #333333;
  margin: 0 10px;
}
.vedio-name .time {
  font-size: 12px;
  color: #999999;
  vertical-align: baseline;
}
.vedio-name.video-other {
  display: inline-block;
  margin-right: 35px;
  margin-bottom: 30px;
  width: 230px;
  vertical-align: top;
}

.vedio-name.video-other:nth-child(3) {
  margin-right: 0;
}
.vedio-name.video-other .userType2::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  background: url("/static/v2/match/Verified_icon_blue_20.png");
  background-size: 16px;
  z-index: 1;
  right: 0;
  bottom: 0;
}
.vedio-name.video-other .img {
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: top;
  position: relative;
  background: rgba(216, 216, 216, 1);
  border: 1px solid rgba(245, 245, 245, 1);
  border-radius: 50%;
}
.vedio-name.video-other .vedio-avatar {
  width: 100%;
  height: 100%;
}

.vedio-name.video-other .vedio-name-center-top {
  margin-left: 10px;
  width: 154px;
  display: inline-block;
}
.vedio-name.video-other .vedio-name-center-top .nickname {
  height: 22px;
  line-height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #999;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 5px;
}
.vedio-name.video-other .vedio-name-center-top .cor {
  color: rgba(153, 153, 153, 1);
}
.vedio-name.video-other .vedio-name-center-top .guestTitle {
  font-size: 14px;
  font-family: NunitoSans-Regular, NunitoSans;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  max-height: 60px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
  width: 154px;
}
.video-other-title {
  height: 30px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 30px;
  margin-bottom: 20px;
}

.vedio-avatar {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.vedio-name-center {
  vertical-align: middle;
  float: left;
  margin-top: 0.28rem;
  margin-left: 0.2rem;
}

.vedio-name-center-top {
  font-size: 0.22rem;
  color: #333333;
}

.vedio-name-center-bottom {
  font-size: 0.16rem;
  color: #777777;
  margin-top: 0.05rem;
}

.vedio-name-focus {
  display: inline-block;
  padding: 0 10px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border: 1px solid rgba(32, 38, 204, 1);
  color: #2026cc;
  font-size: 12px;
  cursor: pointer;
  margin-right: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}

.vedio-name-focus.vedio-name-focusd {
  border: 1px solid grey;
  color: #fff;
  background: #b8b8b8;
}

.vedio-name-focus.vedio-name-focusd::before {
  content: "";
  background: url(/static/v2/match/channel_follow_btn_ticked.png);
  display: inline-block;
  margin-right: 5px;
  height: 12px;
  width: 12px;
  background-size: 12px;
  top: 1px;
  position: relative;
}
.vedio-intro {
  clear: both;
  margin-top: 0.4rem;
}

.vedio-intro .software {
  margin: 20px 0;
  width: 740px;
  height: 80px;
  line-height: 80px;
  padding-left: 20px;
  border: 1px solid rgba(235, 235, 235, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}
.vedio-intro .software span {
  margin-left: 10px;
  font-size: 14px;
  font-family: NunitoSans-Regular, NunitoSans;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.intro-title {
  width: 40px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 28px;
  margin-bottom: 20px;
}

.intro-content {
  font-size: 14px;
  color: #333333;
  table-layout: fixed;
  word-break: break-word;
  overflow: hidden;
  line-height: 24px;
}

.middle-left-2-1 {
  height: 2.9rem;
  color: #000;
  font-size: 0.2rem;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
  margin: 0 -0.6rem;
  overflow: hidden;
  zoom: 1;
}

.middle-left-2-1 span {
  color: #0060ff;
  text-decoration: underline #0060ff;
  cursor: pointer;
}

.middle-left-2-1.logout {
  text-align: center;
  padding-top: 1.38rem;
}

.middle-left-2-1.login .typearea {
  margin: 0 0.6rem;
  position: relative;
}

.middle-left-2-1.login .typearea textarea {
  height: 1.6rem;
  border: 1px solid #eeeeee;
  outline: none;
  background-color: #f9f9f9;
  font-size: 0.14rem;
  color: #999999;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.18rem;
  resize: none;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.middle-left-2-1.login .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
  text-decoration: none;
}

.comment-btn {
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 1.52rem;
  height: 0.46rem;
  line-height: 0.42rem;
  border: 0.02rem solid #0161ff;
  font-size: 0.18rem;
  color: #0161ff;
  text-align: center;
  background-color: #fff;
  -webkit-border-radius: 0.21rem;
  -moz-border-radius: 0.21rem;
  border-radius: 0.23rem;
  float: right;
  margin-right: 0.6rem;
  margin-top: 0.24rem;
}

.middle-left-2-2 {
  padding-top: 0.18rem;
}

.middle-left-2-2 .sum {
  font-size: 0.18rem;
  color: #777;
}

.middle-left-2-2 .sum span {
  font-size: 0.22rem;
  color: #333;
}

.comment-item {
  padding: 0.4rem 0;
  border-bottom: 1px solid #eeeeee;
  clear: both;
}

.comment-item-content {
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.comment-avatar {
  width: 0.5rem;
  height: 0.5rem;
  float: left;
  border-radius: 0.4rem;
}

.comment-middle {
  margin-left: 0.18rem;
  float: left;
  width: 7rem;
  overflow: hidden;
  zoom: 1;
}

.comment-name {
  font-size: 0.18rem;
  color: #333;
  vertical-align: bottom;
  font-weight: bold;
  display: inline-block;
}

.comment-time {
  font-size: 0.16rem;
  color: #999;
  vertical-align: bottom;
}

.comment-middle-2 {
  font-size: 0.16rem;
  color: #777;
  margin-top: 0.15rem;
  line-height: 0.26rem;
}

.comment-right {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.16rem;
  color: #777;
}

.comment-count,
.ding-count {
  display: inline-block;
}

.comment-count-icon {
  display: inline-block;
  width: 0.18rem;
  height: 0.18rem;
  background: url("/static/vedio/comment.png") no-repeat center center;
  background-size: contain;
  margin-right: 0.1rem;
  vertical-align: top;
  cursor: pointer;
}

.ding-count-icon {
  display: inline-block;
  width: 0.18rem;
  height: 0.18rem;
  margin: -0.03rem 0.1rem 0 0.2rem;
  vertical-align: top;
  cursor: pointer;
  font-size: 0.22rem;
}

.ding-count-icon-active {
  color: #0060ff;
}

.comment-reply {
  clear: both;
  margin-left: 0.68rem;
  margin-top: 0.25rem;
  background-color: #f9f9f9;
  border: 1px solid #eeeeee;
  position: relative;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0.22rem 0.19rem;
}

.comment-reply:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 0.105rem solid transparent;
  border-left: 0.105rem solid transparent;
  border-top: none;
  border-bottom: 0.13rem solid #eeeeee;
  top: -0.13rem;
  left: 0.43rem;
}

.comment-reply:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 0.105rem solid transparent;
  border-left: 0.105rem solid transparent;
  border-top: none;
  border-bottom: 0.13rem solid #f9f9f9;
  top: -0.11rem;
  left: 0.43rem;
}

.comment-reply-form {
  margin-top: 0.2rem;
  padding-left: 0.68rem;
  position: relative;
}

.comment-reply-form textarea {
  border: 1px solid #eeeeee;
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.19rem 0.2rem;
  font-size: 0.16rem;
  color: #777;
  resize: none;
  outline: none;
  height: 1.6rem;
}

.comment-reply-form .typearea {
  position: relative;
}

.comment-reply-form .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
}

.reply-btns {
  text-align: right;
  margin-top: 0.24rem;
}

.reply-btns button {
  width: 1.52rem;
  height: 0.46rem;
  line-height: 0.46rem;
  text-align: center;
  padding: 0;
  -webkit-border-radius: 0.23rem;
  -moz-border-radius: 0.23rem;
  border-radius: 0.23rem;
  border: 0.02rem solid;
  background-color: #fff;
  font-size: 0.18rem;
}

.reply-btns .reply-btn-cancel {
  border-color: #777777;
  color: #777777;
  margin-right: 0.2rem;
}

.reply-btn-yes {
  border-color: #0161ff;
  color: #0161ff;
}

.comment-more {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.18rem;
  color: #0161ff;
  cursor: pointer;
}

.middle-right {
  width: 285px;
  float: left;
  margin-left: 65px;
  min-height: 1px;
}
.middle-right-1 {
  margin-bottom: 70px;
}
.middle-right-1 .app_promo {
  display: inline-block;
  width: 285px;
  height: 340px;
}

.middle-right-2 {
  margin-top: 0.2rem;
}

.middle-right-title {
  font-size: 0.3rem;
  color: #333333;
  font-weight: bold;
  margin-left: -0.25rem;
  padding-left: 0.25rem;
  position: relative;
}

.middle-right-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.08rem;
  display: block;
  width: 0.06rem;
  height: 0.28rem;
  background-color: #0161ff;
  -webkit-border-radius: 0.03rem;
  -moz-border-radius: 0.03rem;
  border-radius: 0.03rem;
  margin-bottom: 0.3rem;
}

.biaoqian-item {
  display: inline-block;
  padding: 0.08rem 0.2rem;
  font-size: 0.18rem;
  color: #777777;
  margin: 0.1rem 0.05rem;
  border: 1px solid #dddddd;
  -webkit-border-radius: 0.3rem;
  -moz-border-radius: 0.3rem;
  border-radius: 0.3rem;
  max-width: 2.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.biaoqian-item:hover {
  border-color: #0060ff;
  color: #0060ff;
}

.middle-right-subtitle {
  position: absolute;
  right: 0.4rem;
  top: 0.5rem;
  font-size: 0.18rem;
  color: #777;
}

.middle-right-img {
  width: 3.3rem;
  height: 1.88rem;
  display: block;
  -webkit-border-radius: 0.06rem;
  -moz-border-radius: 0.06rem;
  border-radius: 0.06rem;
  margin-top: 0.3rem;
}

.shareCodeContainer {
  width: 270px;
  padding: 10px 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
.shareCodeContainer1 {
  width: 50px !important;
  height: 30px;
  line-height: 30px;
  text-align: center;
  padding: 0;
  margin: 0;
}
.shareCodeContainer .share a {
  margin-right: 25px;
  display: inline-block;
}
.shareCodeContainer .share a:nth-child(5) {
  margin-right: 0;
}
.shareCodeContainer .video {
  margin-top: 30px;
  font-size: 0;
}
.shareCodeContainer .video p {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 10, 10, 1);
  line-height: 20px;
}
.shareCodeContainer .video input {
  display: inline-block;
  width: 180px;
  height: 30px;
  font-size: 14px;
  font-family: SFProText-Regular, SFProText;
  font-weight: 400;
}
.shareCodeContainer .video span {
  width: 90px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.shareCodeContainer-row {
  line-height: 0.43rem;
  font-size: 0.16rem;
  color: #000000;
}

.share-tip {
  font-size: 0.2rem;
  display: inline-block;
  width: 0.7rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  color: #fff;
  background-color: #0060ff;
  margin-right: 0.2rem;
}

.sharecode-content {
  line-height: 0.28rem;
  border: 0.01rem solid #999999;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: middle;
  padding: 0 5px;
}

.sharecode-btn {
  font-size: 0.2rem;
  display: inline-block;
  width: 0.7rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  color: #fff;
  background-color: #0060ff;
  padding: 0;
  vertical-align: middle;
  border: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.bdsharebuttonbox {
  display: inline-block;
  vertical-align: middle;
}

.report:hover {
  cursor: pointer;
}

.el-dialog__body {
  padding: 0 0.6rem;
  padding-bottom: 0.2rem;
}

.el-dialog {
  border-radius: 0.3rem;
}

.el-form-item__label {
  font-size: 0.2rem;
}

.el-checkbox {
  display: block;
  margin-left: 0 !important;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-form-item {
  margin-bottom: 0;
}

.el-textarea__inner {
  height: 1.4rem;
  border-radius: 0.1rem;
  padding: 0.12rem 0.3rem;
  margin-top: 0.1rem;
}

.el-button {
  width: 1.3rem;
  height: 0.4rem;
  border-radius: 0.3rem;
  line-height: 0.4rem;
  padding: 0;
  margin-top: 0.3rem;
}

.message {
  margin-top: 0.1rem;
  color: #c2c2c2;
}

.photoAlbum p {
  width: 80px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 28px;
  margin-bottom: 20px;
  margin-top: 40px;
}

.photoAlbum ul {
  height: 95px;
  position: relative;
  margin-bottom: 50px;
}
.photoAlbum ul span {
  position: absolute;
  width: 95px;
  height: 95px;
  line-height: 95px;
  text-align: center;
  right: 35px;
  top: 0;
  font-size: 20px;
  font-family: NunitoSans-SemiBold, NunitoSans;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
}
.photoAlbum ul li {
  width: 95px;
  height: 95px;
  margin-right: 10px;
  float: left;
}
.photoAlbum ul li img {
  width: 100%;
  height: 100%;
}
.title-switch span {
  outline: none !important;
}

.video-player .video-js {
  width: 100%;
  height: 100%;
}
</style>


<style lang="stylus" scoped>
.tixing {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.top_live {
  width: 1110px;
  padding-bottom: 50px;
  border-bottom: 1px solid #EBEBEB;
  // margin-bottom: 40px;
  font-size: 0;

  .detailImg {
    width: 445px;
    height: 250px;
    position: relative;
    display: inline-block;

    .topImg {
      width: 100%;
      height: 100%;
      display: inline-block;
    }

    .status {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 0 16px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-size: 100%;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 0px 4px 0px 0px;
    }

    .status-notstarted {
      background: linear-gradient(135deg, rgba(54, 100, 237, 0.9) 0%, rgba(32, 38, 204, 0.9) 100%);
    }

    .status-living {
      background: linear-gradient(135deg, rgba(254, 161, 116, 0.9) 0%, rgba(254, 86, 48, 0.9) 100%);

      img {
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: text-top;
        margin-right: 4px;
      }
    }

    .status-closed {
      background: linear-gradient(135deg, rgba(204, 204, 204, 0.9) 0%, rgba(153, 153, 153, 0.9) 100%);
    }
  }

  .liveDetail {
    display: inline-block;
    width: 635px;
    margin-left: 30px;
    vertical-align: top;

    .title1 {
      wdith: 100%;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(10, 10, 10, 1);
      line-height: 32px;
      margin-bottom: 10px;
    }

    .title2 {
      max-height: 42px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 21px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin-bottom: 10px;
    }

    .distinguished {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(51, 51, 51, 1);
      line-height: 21px;

      span {
        color: #999;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;

        i {
          background: rgba(184, 184, 184, 1);
          display: inline-block;
          width: 3px;
          height: 3px;
          border-radius: 50%;
          vertical-align: middle;
        }
      }

      span.left {
        color: #666;
        font-weight: 400;
      }

      span.cor {
        color: #333;
        cursor: pointer;

        &:hover {
          color: #0a0a0a;
        }
      }

      span:last-child {
        i {
          display: none;
        }
      }
    }

    .time {
      height: 21px;
      font-size: 14px;
      font-family: NunitoSans-Regular, NunitoSans;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 21px;
      margin: 13px 0 19px 0;
    }

    .price {
      height: 27px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 400;
      color: rgba(252, 98, 64, 1);
      line-height: 27px;
      margin-bottom: 15px;

      b {
        font-weight: 600;
      }
    }

    .free {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 400;
      color: rgba(252, 98, 64, 1);
      line-height: 25px;
      margin-bottom: 17px;
    }

    .bottom {
      .sub {
        display: inline-block;
      }

      .bottom1 {
        width: 140px;
        height: 40px;
        background: rgba(32, 38, 204, 1);
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 40px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        margin-right: 12px;

        &:hover {
          background: rgba(28, 33, 176, 1);
        }
      }

      .bottom2 {
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid rgba(32, 38, 204, 1);
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(32, 38, 204, 1);
        cursor: pointer;

        img {
          width: 18px;
          height: 18px;
          display: inline-block;
          margin-right: 8px;
          margin-bottom: 3px;
        }
      }

      .bottom3 {
        width: 90px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid rgba(102, 102, 102, 1);
        float: right;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(10, 10, 10, 1);
        display: inline-block;
        cursor: pointer;
        margin-top: 6px;
      }

      .bottom4 {
        display: inline-block;
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: rgba(32, 38, 204, 1);
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;

        &:hover {
          background: rgba(28, 33, 176, 1);
        }
      }

      .bottom5 {
        display: inline-block;
        width: 140px;
        height: 40px;
        border: 1px solid rgba(184, 184, 184, 1);
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(184, 184, 184, 1);
        cursor: pointer;

        &:hover {
          border: 1px solid rgba(153, 153, 153, 1);
          color: rgba(153, 153, 153, 1);
        }

        .hover2 {
          display: none;
        }

        &:hover .hover2 {
          display: block;
        }

        &:hover .hover1 {
          display: none;
        }
      }
    }
  }
}

.distinguishedList {
  .box {
    .cor {
      cursor: pointer;

      .nickname {
        color: #0a0a0a;
      }
    }
  }
}

.detail {
  font-size: 20px;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 28px;
  margin: 40px 0 20px 0;

  .title_detail {
    margin-bottom: 20px;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    font-weight: 600;
    color: rgba(10, 10, 10, 1);
  }

  .liveText {
    color: #333;
    font-size: 14px;
    font-weight: normal;
  }

  >>> .liveText {
    p {
      min-height: 30px;
    }
  }
}

.channel {
  margin-top: 20px;
  display: inline-block;

  .img {
    width: 65px;
    height: 65px;
    display: inline-block;
    border: 1px solid #f5f5f5;
    box-sizing: border-box;

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  .text {
    margin-left: 10px;
    width: 195px;
    display: inline-block;
    vertical-align: top;

    .title1 {
      width: 210px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 38px;
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(10, 10, 10, 1);
      line-height: 19px;
    }

    .title2 {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 17px;
      margin-top: 5px;

      span {
        margin-right: 8px;
      }
    }
  }
}

.top-bottom-icon.icon-weibo {
  background: url('/static/v2/match/share_weibo.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-weibo:hover {
  background: url('/static/v2/match/share_weibo_hover.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-wechat {
  background: url('/static/vedio/share_wechat@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-wechat:hover {
  background: url('/static/vedio/share_wechat_hover@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-qq {
  background: url('/static/vedio/share_qq@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-qq:hover {
  background: url('/static/vedio/share_qq_hover@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-twi {
  background: url('/static/vedio/share_twitter@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-twi:hover {
  background: url('/static/vedio/share_twitter_hover@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-face {
  background: url('/static/vedio/share_fb@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-face:hover {
  background: url('/static/vedio/share_fb_hover@2x.png') no-repeat center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.popup {
  position: absolute;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .popupBox {
    width: 380px;
    height: 240px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      float: none;

      span {
        background: url('/static/close_btn@2x.png');
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 20px;
        top: 23px;
        cursor: pointer;
      }
    }

    .line {
      height: 1px;
      width: 100%;
      background: #E0E0E0;
    }

    .subImg {
      display: inline-block;
      width: 64px;
      height: 64px;
      margin: 15px 158px;
    }

    .text {
      height: 48px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      padding: 0 20px;
      text-align: center;
    }
  }
}

.container {
  width: 1110px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newLive/liveDetail.vue